(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["education-resources"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initSection = (sectionId) => {
      const playBtn = document.getElementById(`PlayBtn-${sectionId}`);
      const overlay = document.getElementById(`Overlay-${sectionId}`);
      if (!playBtn || !overlay) return;

      playBtn.addEventListener('click', () => {
        const container = overlay.closest('.education-resources__video-container');
        const deferredMedia = container.querySelector('deferred-media');
        if (deferredMedia) {
          const posterBtn = deferredMedia.querySelector('.deferred-media__poster-button');
          if (posterBtn) {
            posterBtn.click();
          } else {
            const iframe = deferredMedia.querySelector('iframe');
            const videoEl = deferredMedia.querySelector('video');
            if (videoEl) {
              videoEl.play();
            } else if (iframe) {
              const type = iframe.dataset.videoType;
              iframe.contentWindow?.postMessage(
                type === 'youtube'
                  ? '{"event":"command","func":"playVideo","args":""}'
                  : '{"method":"play"}',
                '*'
              );
            }
          }
        }
        overlay.classList.add('education-resources__overlay--hidden');
      });
    };

    // Initialize all existing sections on load
    document.querySelectorAll('.education-resources').forEach((el) => {
      const testId = el.getAttribute('data-testid');
      if (testId) {
        const sectionId = testId.replace('education-resources-', '');
        initSection(sectionId);
      }
    });

    // Support theme editor updates
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('education-resources')) {
        const testId = event.target.getAttribute('data-testid');
        if (testId) {
          const sectionId = testId.replace('education-resources-', '');
          initSection(sectionId);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class TestimonialsCarousel {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('.testimonials__track');
        this.cards = Array.from(root.querySelectorAll('.testimonials__card'));
        this.section = root.closest('.testimonials');
        this.index = 0;
        this.bind();
        this.update();
      }

      perView() {
        const width = window.innerWidth;
        if (width <= 749) return 1;
        if (width <= 990) return 2;
        return parseInt(this.root.dataset.perView, 10) || 3;
      }

      maxIndex() {
        return Math.max(0, this.cards.length - this.perView());
      }

      bind() {
        const buttons = this.section
          ? this.section.querySelectorAll('.testimonials__arrow')
          : [];
        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const dir = btn.dataset.direction === 'next' ? 1 : -1;
            this.move(dir);
          });
        });
        window.addEventListener('resize', () => this.update());
      }

      move(dir) {
        const max = this.maxIndex();
        this.index += dir;
        if (this.index < 0) this.index = max;
        if (this.index > max) this.index = 0;
        this.update();
      }

      update() {
        if (!this.cards.length) return;
        this.index = Math.min(this.index, this.maxIndex());
        const card = this.cards[0];
        const style = window.getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        this.track.style.transform = `translateX(-${this.index * step}px)`;
      }
    }

    function init() {
      document
        .querySelectorAll('.testimonials__carousel')
        .forEach((el) => new TestimonialsCarousel(el));
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
